<template>
  <div class="picture-gallery-overview">
    <MediaGallery :mediaType="mapImagesMediaType" :singleRow="true" :files="mapImages" :loading="mapImagesLoading" :externalLink="mapImagesExternalLink" @onFirstUploaded="loadMediaLocationLinkFunction(mapImagesMediaType, 'mapImagesExternalLink')"/>
    <MediaGallery :mediaType="projectPhotosMediaType" :singleRow="true" :files="pictures" :loading="projectPhotosLoading" :externalLink="projectPhotosExternalLink" @onFirstUploaded="loadMediaLocationLinkFunction(projectPhotosMediaType, 'projectPhotosExternalLink')"/>
    <div id="projectContextMenuPopup" class="right-click-menu">
      <li
        v-if="selectedElement.type === 'PICTURE'"
        @click="openMediaDeleteModal" >
        {{ $t('media.deleteModalTitle') }}
      </li>
      <li
        v-if="selectedElement.type === 'ATTACHMENT'"
        @click="openMediaDeleteModal" >
        {{ $t('attachment.deleteModalTitle') }}
      </li>
    </div>
    <delete-modal/>
  </div>
</template>

<script>
import $ from 'jquery'

import MediaGallery from '@/components/dynamicTables/misc/mediaGallery'
import deleteModal from '@/components/modal/deleteModal.vue'
import stringUtils from '@/utils/stringUtils'

import config from '@/configurations/config'
import Popup from '@/utils/popup'

let popup = Popup[config.platform].default

export default {
  components: {
    MediaGallery,
    deleteModal
  },
  async mounted() {
    await this.setCurrentProject()
    await this.loadMediaTypeData()
  },
  data() {
    return {
      mapImagesLoading: false,
      projectPhotosLoading: false,
      mapImagesExternalLink: '',
      projectPhotosExternalLink: '',
      mapImagesMediaType: config.constants.MediaClassification.MapImages,
      projectPhotosMediaType: config.constants.MediaClassification.ProjectPhoto
    }
  },
  computed: {
    selectedElement: {
      get() {
        return this.$store.state.selectedElement
      },
      set(value) {
        this.$store.commit('setSelectedElement', value)
      }
    },
    mapImages: {
      get() {
        return this.$store.state.mapImages
      },
      set(value) {
        this.$store.commit('setMapImages', value)
      }
    },
    pictures: {
      get() {
        return this.$store.state.pictures
      },
      set(value) {
        this.$store.commit('setPictures', value)
      }
    }
  },
  methods: {
    openMediaDeleteModal() {
      let modal = $('#modalDelete')
      modal.on('shown.bs.modal', function (e) {
        $('#txtActionCode').focus()
      })
      modal.modal('toggle')
    },
    async setCurrentProject() {
      if (stringUtils.isNullOrEmptyOrWhitespace(this.$route.params.projectId)) {
        popup.popup(this.$t('message.projectNotFound'))
        return
      }

      await this.$store.dispatch('fetchProject', {
        PrID: this.$route.params.projectId
      })
      const project = this.$store.state.currentProject

      if (project && project.PrID) {
        this.projectCode = project.PrCode
      } else {
        popup.popup(this.$t('message.projectNotFound'))
      }
    },
    async loadMediaLocationLinkFunction(mediaClassification, externalLinkMediaType) {
      const response = await this.$store.dispatch('loadMediaLocationLink', {
        mediaType: mediaClassification
      })

      this[externalLinkMediaType] = response.data.Link
    },
    async setProjectPhotos() {
      this.projectPhotosLoading = true
      await Promise.all([
        this.loadMediaLocationLinkFunction(this.projectPhotosMediaType, 'projectPhotosExternalLink'),
        this.getProjectMediaListFunction(this.projectPhotosMediaType, 'pictures')])
      this.projectPhotosLoading = false
    },
    async setMapImages() {
      this.mapImagesLoading = true
      await Promise.all([
        this.loadMediaLocationLinkFunction(this.mapImagesMediaType, 'mapImagesExternalLink'),
        this.getProjectMediaListFunction(this.mapImagesMediaType, 'mapImages')])
      this.mapImagesLoading = false
    },
    async loadMediaTypeData() {
      await Promise.all([this.setMapImages(), this.setProjectPhotos()])
    },
    async getProjectMediaListFunction(mediaClassification, filesMediaTypeName) {
      const response = await this.$store.dispatch('getProjectMediaList', {
        mediaType: mediaClassification
      })

      this.handleMediaResponse(response, mediaClassification, filesMediaTypeName)
    },
    handleMediaResponse(mediaListRes, mediaClassification, filesMediaTypeName) {
      if (!mediaListRes.data || mediaListRes.data.ResultCode !== 'GetMediaList_Success') {
        this[filesMediaTypeName] = []
        return
      }
      if (typeof mediaListRes.data.files === 'undefined') {
        this[filesMediaTypeName] = []
        return
      }
      if (mediaClassification !== this.mapImagesMediaType && mediaClassification !== this.projectPhotosMediaType) {
        this.handlerError(new Error('ERROR: Unknown mediaClassification: ' + mediaClassification))
        this[filesMediaTypeName] = []
        return
      }

      this[filesMediaTypeName] = mediaListRes.data.files
    },
    handlerError(err) {
      if (err && err.ResultCode && err.ResultCode === 'MeasurementPoint_UNKNOWN_ERROR') {
        popup.popup(err.ResultMessage)
        return
      }
      popup.popup(err.body)
    }
  }
}
</script>

<style scoped lang="less">
.picture-gallery-overview {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
</style>
